<template>
    <div>
        <el-dialog title="指定下载人" class="edit-dialog" :visible.sync="showEdit" :before-close="close" center>
            <el-form ref="editForm" class="editForm" :model="editForm" label-width="20%">
                <el-form-item v-for="(item, index) in editForm.usernameList" :key="`usernameList${index}`" :label="'下载人'"
                    :prop="'usernameList.' + index" :rules="{
                        required: true, message: '请选择指定下载人', trigger: 'change'
                    }">
                    <el-select v-model="item.userName" placeholder="请选择" clearable @change="select_chang">
                        <el-option v-for="ite in filterOpData" :key="ite.id" :value="`${ite.userName}`"
                            :label="`${ite.chineseName || '暂无'} - ${ite.workno || '暂无'}`" :disabled="ite.disabled">
                            {{ ite.chineseName || '暂无' }} - {{ ite.workno || '暂无' }}
                        </el-option>
                    </el-select>
                    <div class="operate">
                        <i class="el-icon-circle-plus-outline" @click="addApprovers" />
                        <i class="el-icon-remove-outline" @click="deleteApprovers(index)" v-if="index > 0" />
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editEventForm()">提 交</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
// import { update } from '@/api/baseFlowConfig'
import { queryUserInfo } from '@/api/basicInfo'
import { compApplyRelPeople } from '@/api/comprehensive'
export default {
    data() {
        return {
            editForm: {
                applyNo: '',
                usernameList: []
            },
            loading: false,
            userName: '',
            showEdit: false,
            columnDefs: [
                { label: '流程分类', prop: 'flowName' },
                { label: '操作', prop: 'operate' }
            ],
            staffList: [],
            selectUserNameList: [],
            selectData: []
        }
    },
    computed: {
        filterOpData() {
            let getSels = []
            this.editForm.usernameList.map(item => {
                item.userName && getSels.push(item.userName)
            })
            return this.staffList.filter(item => {
                getSels.includes(item.userName) && (item.disabled = true)
                return true
            })
        },
        select_chang() {
            let getSels = []
            this.editForm.usernameList.map(item => {
                item.userName && getSels.push(item.userName)
            })
            return this.staffList.filter(item => {
                item.disabled = false
                // getSels.includes(item.id) && (item.disabled=false)
                return false
            })
        },
    },
    methods: {
        add() {
            this.selectData.push({ Select: '' });
        },
        del(index) {
            this.selectData.splice(index, 1);
        },
        async edit(row) {
            console.log(row);
            const { result } = await compApplyRelPeople('listDownloader', { applyNo: row.eventId })
            this.showEdit = true
            this.editForm = {
                applyNo: row.eventId,
                usernameList: result.length === 0 ? [{ userName: this.userName }] : result.map(v => { return { userName: v } })
                // usernameList: []
            }
            this.selectUserNameList = this.staffList.map(v => v.userName)
           console.log(this.editForm);
        },
        close() {
            this.showEdit = false
        },
        getStaffList() {
            queryUserInfo({
                enableStatus: '1'
            }).then(res => {
                const { code, result } = res
                if (code !== 0) return
                this.staffList = result.records
            })
        },
        editEventForm() {
            console.log(this.editForm);
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    let userNamevalid = this.editForm.usernameList.every(v => {
                        return v.userName !== ''
                    })
                    console.log(userNamevalid);
                    if (!userNamevalid) {
                        this.$message.warning('请选择下载人，不能为空！')
                        return 
                    }
                    compApplyRelPeople('specifyDownloader', {
                        applyNo: this.editForm.applyNo,
                        usernameList: this.editForm.usernameList.map(v => v.userName)
                    }).then(res => {
                        const { code } = res
                        if (code !== 0) return
                        this.$message.success('编辑流程成功')
                        this.showEdit = false
                        this.getData()
                    })
                }
            })
        },
        addApprovers() {
            this.editForm.usernameList.push({ userName: '' })
        },
        deleteApprovers(index) {
            this.editForm.usernameList.splice(index, 1)
        },
    },
    mounted() {
        this.userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName || ''
        this.getStaffList()
    }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
    min-width: 500px;
    width: 30%;
}

.edit-dialog {
    .editForm {
        max-height: 50vh;
        overflow-x: scroll;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .operate {
        display: inline-block;
        font-size: 24px;

        i {
            margin: 0 5px;
        }
    }
}
</style>
